import type * as React from "react";

export {
  AlertCircle,
  AlertTriangle,
  ArrowLeft,
  ArrowRight,
  Bell,
  Bookmark,
  Briefcase,
  Calendar,
  CalendarDays,
  Camera,
  Check,
  CheckCheck,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleCheckBig,
  CircleHelp,
  CircleX,
  ClipboardCheck,
  Clock,
  Copy,
  CreditCard,
  Euro,
  Eye,
  EyeOff,
  Heart,
  Home,
  Hourglass,
  Image,
  Info,
  LayoutGrid,
  Link2,
  LoaderCircle,
  LogOut,
  MapPin,
  Menu,
  MessageCircle,
  Mic,
  Minus,
  MoreHorizontal,
  MoreVertical,
  Navigation,
  Paperclip,
  Pencil,
  Phone,
  Plus,
  Search,
  Send,
  Settings,
  Share2,
  ShieldCheck,
  ShoppingCart,
  SlidersHorizontal,
  Sparkles,
  SquarePen,
  Star,
  Trash2,
  User,
  Users,
  X,
} from "lucide-react";

/** The 61 names both kits share; icons.guard.test.ts holds this list to icons.json. */
export const REGISTRY = [
  "AlertCircle",
  "AlertTriangle",
  "ArrowLeft",
  "ArrowRight",
  "Bell",
  "Bookmark",
  "Briefcase",
  "Calendar",
  "CalendarDays",
  "Camera",
  "Check",
  "CheckCheck",
  "ChevronDown",
  "ChevronLeft",
  "ChevronRight",
  "ChevronUp",
  "CircleCheckBig",
  "CircleHelp",
  "CircleX",
  "ClipboardCheck",
  "Clock",
  "Copy",
  "CreditCard",
  "Euro",
  "Eye",
  "EyeOff",
  "Heart",
  "Home",
  "Hourglass",
  "Image",
  "Info",
  "LayoutGrid",
  "Link2",
  "LoaderCircle",
  "LogOut",
  "MapPin",
  "Menu",
  "MessageCircle",
  "Mic",
  "Minus",
  "MoreHorizontal",
  "MoreVertical",
  "Navigation",
  "Paperclip",
  "Pencil",
  "Phone",
  "Plus",
  "Search",
  "Send",
  "Settings",
  "Share2",
  "ShieldCheck",
  "ShoppingCart",
  "SlidersHorizontal",
  "Sparkles",
  "SquarePen",
  "Star",
  "Trash2",
  "User",
  "Users",
  "X",
] as const;

/** tokens.json `icon`, typed here so a client bundle does not ship the whole token file; the guard pins it. */
export const ICON_SIZE = { sm: 16, md: 20, lg: 24, xl: 32 } as const;

export interface IconProps {
  size?: number | string;
  className?: string;
  strokeWidth?: number | string;
  fill?: string;
  role?: string;
  "aria-hidden"?: boolean | "true" | "false";
  "aria-label"?: string;
}

export type IconComponent = React.ComponentType<IconProps>;
